interface InputLabelProps {
    text?: string;
    className?: string;
}
const InputLabel: React.FC<InputLabelProps> = (props) => {
    const className = props.className ? props.className : '';
    return (
        <p className={'text-sm text-gray-500 mx-1 mt-1 mb-0.5 ' + className}>
            {props.text}
        </p>
    );
};

export default InputLabel;
